<template>
  <div
    v-if="rowsConverted.length"
    :class="`as-parent-standing as-parent-standing-${siteName}`"
    ref="standingRef"
  >
    <div class="as-standing__top as-row-name" v-if="rowsTitles[0]?.title">
      <TabsBtn
        :tabs="rowsTitles"
        :activeTab="activeTitle"
        @change="changeTitles"
      />
    </div>
    <div class="as-standing__top">
      <TabsBtn :tabs="tabs" :activeTab="activeTab" @change="changeTab" />
      <div
        class="as-menu"
        :class="{
          'as-active': isShowFull,
        }"
        @click="handleShowFull"
      >
        <IconMenu />
      </div>
    </div>

    <div
      class="as-standing"
      :class="{
        'as-show-full': isShowFull,
        'as-scrolling as-scrolling__have-tab as-scrolling__result-popup as-volleyball':
          isPopup,
      }"
      v-for="(rows, key) in rowsConverted"
      :key="key"
    >
      <div class="as-standing__table">
        <div
          :class="[
            'as-standing__table-row',
            'as-standing__table-row-head',
          ]"
        >
          <div
            v-for="column in columns"
            :key="column.name"
            @click="sortData(column.name)"
            :class="`as-standing__table-column ${column.class}`"
            type="button"
            :ref="column.name === 'next' ? 'activeItems' : undefined"
          >
            <div v-if="column.name === 'points1'" class="as-has-arrow-right">
              <div class="as-has-arrow-right-info">
                {{ column.title }}
                <IconArrownDown
                  v-if="sort.column === column.name"
                  class="as-d-inline-flex"
                  :class="{
                    'as-sort-down': sort.type === 'ASC',
                    'as-sort-up': sort.type === 'DESC',
                  }"
                />
              </div>
              <IconArrowRight fill="#CCC" />
            </div>
            <div v-else>
              {{ column.title }}

              <IconArrownDown
                v-if="sort.column === column.name"
                class="as-d-inline-flex"
                :class="{
                  'as-sort-down': sort.type === 'ASC',
                  'as-sort-up': sort.type === 'DESC',
                }"
              />
            </div>
          </div>
        </div>
        <div
          v-for="(row, keyRow) in rows"
          :key="keyRow"
          class="as-standing__table-row"
          :class="{
            active:
              match?.home_team_id === row.team_id ||
              match?.away_team_id === row.team_id,
          }"
        >
          <div
            class="as-standing__table-column as-standing__table-column-stt as-text-center"
            :class="{
              'as-stt-popup': isPopup,
            }"
          >
            <div class="as-stt">
              {{ keyRow + 1 }}
            </div>
          </div>
          <div
            class="as-standing__table-column as-standing__table-column-team"
            :class="{
              'as-team-popup': isPopup,
            }"
          >
            <div class="as-match__team">
              <img
                :src="getImgUrlBySport('team', row.team_id)"
                class="as-match__team-logo"
                :alt="row.team_name"
              />
              <span class="as-standing__table-text">
                {{ row.team_name }}
              </span>
            </div>
          </div>
          <div class="as-standing__table-column as-text-center">
            {{ getRowdata(row, 'p') }}
          </div>
          <div class="as-standing__table-column as-text-center as-c-w">
            {{ getRowdata(row, 'win') }}
          </div>
          <div class="as-standing__table-column as-text-center as-c-l">
            {{ getRowdata(row, 'loss') }}
          </div>
          <div class="as-standing__table-column as-text-center">
            {{ getRowdata(row, 'sets') }}
          </div>
          <div class="as-standing__table-column as-text-center">
            {{ getRowdata(row, 'points') }}
          </div>
          <div class="as-standing__table-column as-text-center as-coulumn-show-full">
            {{ getRowdata(row, 'diff') }}
          </div>
          <div
            class="as-standing__table-column as-text-center as-coulumn-show-full"
          >
            <div class="as-standing-tag__list">
              <button
                v-for="(recent, keyRecent) in getRecent(row)"
                :key="keyRecent"
                :class="`as-standing-tag as-standing-tag__${determineMatchResultVolleyball(
                  recent,
                  row.team_id
                ).charAt(0)}`"
                :title="getRecentTitle(recent, row.team_id)"
              >
                {{ determineMatchResultVolleyball(recent, row.team_id).charAt(0) }}
              </button>
            </div>
          </div>
          <!-- <div
            class="as-standing__table-column as-text-center as-coulumn-show-full"
          >
            <img
              :src="getRowdata(row, 'next')"
              class="as-match__team-logo"
              :alt="row.team_name"
            />
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <NoData v-else />
</template>

<script setup lang="ts">
import { defineProps, ref, computed, nextTick, onMounted, getCurrentInstance } from "vue";
import IconArrownDown from "~src/components/icons/IconArrownDown.vue";
import IconMenu from "~src/components/icons/IconMenu.vue";
import NoData from "~src/components/NoData.vue";
import TabsBtn from "~src/components/TabsBtn.vue";
import IconArrowRight from "~src/components/icons/IconArrowRight.vue";
import type {
  IStanding,
  IMatch,
  ITeam,
  IStandingsRow,
  IStandingsTable,
  IPromotion,
  IRecent,
} from "~src/interfaces//basketball";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import {
  determineMatchResult,
  determineMatchResultVolleyball,
  getTeamName,
} from "~src/helpers/basketball/index";
import MatchEnum from "~src/enums/MatchEnum";
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();

interface IProps {
  standing: IStanding;
  match?: IMatch;
  isPopup: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isPopup: true,
});

const siteName = computed(() => commonStore.getSiteName);
const isShowFull = ref(false);
const activeTab = ref("all");
const tabs = ref([
  {
    title: "Tất cả",
    key: "all",
  },
  {
    title: "Sân nhà",
    key: "home",
  },
  {
    title: "Sân khách",
    key: "away",
  },
]);

const columns = [
  {
    title: "#",
    name: "position",
    class: "as-text-center as-standing__table-column-stt as-column-head",
  },
  {
    title: "Team",
    name: "team_name",
    class: "as-standing__table-column-team as-column-head",
  },
  {
    title: "P",
    name: "mb",
    class: "as-text-center as-c-mb",
  },
  {
    title: "W",
    name: "won",
    class: "as-text-center as-c-w",
  },
  {
    title: "L",
    name: "lost",
    class: "as-text-center as-c-l",
  },
  {
    title: "S",
    name: "s",
    class: "as-text-center as-c-s",
  },
  {
    title: "PTS",
    name: "pts",
    class: "as-text-center as-c-pts",
  },
  {
    title: "Diff",
    name: "diff",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "Phong độ",
    name: "points1",
    class: "as-text-center as-scroll-item-active as-coulumn-show-full",
  },
  // {
  //   title: "Tiếp",
  //   name: "next",
  //   class:
  //     "as-text-center as-scroll-item-active as-column-next as-coulumn-show-full",
  // },
];

const sort = ref({
  column: "",
  type: "ASC",
});

const activeTitle = ref("");
const changeTitles = (val: string) => {
  activeTitle.value = val;
};

const rowsTitles = computed(() => {
  if (!props?.standing?.standings) {
    return [];
  }

  const _rowsTitles: any = [];
    props.standing.standings.map((item: any) => {
      _rowsTitles.push({
          key: item.id,
          title: item.name,
        });
    });


  return _rowsTitles;
});

const rowsConverted = computed(() => {
  if (!props?.standing?.standings) {
    return [];
  }
  const standingJson: any = [];
  let __standings: any[] = props.standing.standings;
  if (activeTitle.value) {
    __standings = __standings.filter(
      (item: any) => item.id === activeTitle.value
    );
  }
  const instance: any = getCurrentInstance();

  __standings.map((item: any) => {
    const rows = [];
    for (const row of item.rows) {
      const _won = Number(row.won || 0);
      const _lost = Number(row.lost || 0);
      const _p = _won + _lost;
      const _pct = _p ? (Number(_won / _p || 0) * 100).toFixed(1) || "0" : 0;
      rows.push({
        ...row,
        team_name: getTeamName(props.standing.teams, row.team_id),
        next:
          row?.next_match?.home_team?.id === row.team_id
            ?  instance.proxy?.getImgUrlBySport("team", row?.next_match?.away_team?.id)
            :  instance.proxy?.getImgUrlBySport("team", row?.next_match?.home_team?.id),
        won: _won,
        lost: _lost,
        p: _p,
        pct: _pct,
        pts: row.points || 0,
      });
    }

    rows?.sort((a: any, b: any) => {
      if (activeTab.value === "all") {
        // chọn sắp xếp
        if (sort.value.column) {
          // sắp xếp string
          if (sort.value.column === "team_name") {
            if (sort.value.type === "DESC") {
              return a.team_name.localeCompare(b.team_name);
            } else {
              return b.team_name.localeCompare(a.team_name);
            }
          } else {
            if (sort.value.type === "DESC") {
              return a[sort.value.column] - b[sort.value.column];
            } else {
              return b[sort.value.column] - a[sort.value.column];
            }
          }
        } else {
          return a.position - b.position;
        }
      } else {
        if (sort.value.column) {
          if (sort.value.column === "team_name") {
            if (sort.value.type === "DESC") {
              return a.team_name.localeCompare(b.team_name);
            } else {
              return b.team_name.localeCompare(a.team_name);
            }
          } else {
            if (sort.value.type === "DESC") {
              return (
                a[`${activeTab.value}_${sort.value.column}`] -
                b[`${activeTab.value}_${sort.value.column}`]
              );
            } else {
              return (
                b[`${activeTab.value}_${sort.value.column}`] -
                a[`${activeTab.value}_${sort.value.column}`]
              );
            }
          }
        } else {
          return (
            a[`${activeTab.value}_position`] - b[`${activeTab.value}_position`]
          );
        }
      }
    });
    standingJson.push({
      id: item.id,
      name: item.name,
      scope: item.scope,
      rows: rows,
    });
  });

  if (standingJson.length > 1) {
    const { home_team_id, away_team_id } = props.standing.match;
    const result = standingJson.filter((arr: any) => {
      const isIncludeHomeTeam = arr.rows.some(
        (row: any) => row.team_id === home_team_id
      );
      const isIncludeAwayTeam = arr.rows.some(
        (row: any) => row.team_id === away_team_id
      );
      if (isIncludeHomeTeam && isIncludeAwayTeam) {
        return arr;
      }
    });
    const { kind } = props.standing.match;
    if (result.length > 1) {
      const currentSeason = result.filter((arr: any) => {
        // Statistics range，1-season，2-qualifier，3-group stage，4-preseason，5-regular season，6-elimination (playoffs)
        // Type id，1-Regular season，2-Playoffs，3-Preseason，4-All-Star，5-Cup，6-play offs，0-None
        if (kind === 1) {
          return arr.scope === 5;
        }
        if (kind === 2) {
          return arr.scope === 6;
        }
        if (kind === 3) {
          return arr.scope === 4;
        }
      });
      if (currentSeason.length === 0) {
        return result.map((item: any) => {
          return item.rows;
        });
      }
      return currentSeason.map((item: any) => {
        return item.rows;
      });
    }

    if (result.length === 0) {
      let data = standingJson.filter((item: any) => {
        if (kind === 1) {
          return item.scope === 5;
        }
        if (kind === 2) {
          return item.scope === 6;
        }
        if (kind === 3) {
          return item.scope === 4;
        }
      });
      if (data.length === 0) {
        return standingJson.map((item: any) => {
          return item.rows;
        });
      }
      if (data.length <= 2) {
        // two team in two different standing
        data = data.map((i: any) => i.rows);
        return data;
      }
      const result = standingJson.filter((arr: any) => {
        const isIncludeHomeTeam = arr.rows.some(
          (row: any) => row.team_id === home_team_id
        );
        const isIncludeAwayTeam = arr.rows.some(
          (row: any) => row.team_id === away_team_id
        );
        if (isIncludeHomeTeam || isIncludeAwayTeam) {
          return arr;
        }
      });
      if (result.length !== 0) {
        return result.map((item: any) => {
          return item.rows;
        });
      }
      data = data.map((i: any) => i.rows);
      return data;
    }

    return result.map((item: any) => {
      return item.rows;
    });
  }
  const _standings = standingJson.map((item: any) => {
    return item.rows;
  });

  return _standings;
});

const changeTab = (val: string) => {
  activeTab.value = val;
};

const sortData = (columnName: string) => {
  let type = "ASC";
  if (sort.value.column === columnName) {
    if (sort.value.type === "ASC") {
      type = "DESC";
    }
  }
  sort.value = {
    column: columnName,
    type: type,
  };
};

const getRowdata = (row: any, field: string) => {
  if (field === "p") {
    let _win = row.win ?? 0;
    let _loss = row.loss ?? 0;

    if (activeTab.value === "home") {
      _win = row.home_win ?? 0;
      _loss = row.home_lose ?? 0;
    } else if (activeTab.value === "away"){
      _win = row.away_win ?? 0;
      _loss = row.away_lose ?? 0;
    }

    return parseInt(_win + _loss);

  } else if (field === "win") {
    if (activeTab.value === "all") {
      return row.win;
    } else if (activeTab.value === "home") {
      return row.home_win;
    } else {
      return row.away_win;
    }
  } else if (field === "loss") {
    if (activeTab.value === "all") {
      return row.loss;
    } else if (activeTab.value === "home") {
      return row.home_lose;
    } else {
      return row.away_lose;
    }
  } else if (field === "sets") {
    let sets_win = row.sets_win ?? 0;
    let sets_loss = row.sets_loss ?? 0;
    if (activeTab.value === "home") {
      sets_win = row.home_sets_win ?? 0;
      sets_loss = row.home_sets_lose ?? 0;
    } else if (activeTab.value === "away"){
      sets_win = row.away_sets_lose ?? 0;
      sets_loss = row.away_sets_win ?? 0;
    }
    return `${sets_win}:${sets_loss}`;
  } else if (field === "points") {
    if (activeTab.value === "all") {
      return row.points;
    } else if (activeTab.value === "home") {
      return row.home_points ?? 0;
    } else {
      return row.away_points ?? 0;
    }
  } else if (field === "diff") {
    let sets_win = row.sets_win ?? 0;
    let sets_loss = row.sets_loss ?? 0;
    if (activeTab.value === "home") {
      sets_win = row.home_sets_win ?? 0;
      sets_loss = row.home_sets_lose ?? 0;
    } else if (activeTab.value === "away"){
      sets_win = row.away_sets_lose ?? 0;
      sets_loss = row.away_sets_win ?? 0;
    }

    const diff = sets_win - sets_loss;
    
    return diff > 0 ? `+${diff}` : `${diff}`;
  }
};

const getRecentTitle = (recent: any, teamId: string) => {
  const scores = recent?.scores;
  const totalHomeGoals = scores['ft'][0];
  const  totalAwayGoals = scores['ft'][1];

  return `${totalHomeGoals}:${totalAwayGoals} (${
    recent.home_team?.name
  } - ${recent.away_team?.name}) ${formatLocalTime(recent.match_time)}`;
  return 'OK'
};

const getRecent = (row: any) => {
  if (activeTab.value === "all") {
    return row.recent_matches;
  } else {
    return row[`${activeTab.value}_matches`];
  }
};

const getContrastColor = (hexcolor: string) => {
  // Remove the hash if it's there
  hexcolor = hexcolor.replace("#", "");
  if (hexcolor === "") return "white";

  // Parse r, g, b values
  let r = parseInt(hexcolor.substring(0, 2), 16); // hex to integer
  let g = parseInt(hexcolor.substring(2, 4), 16);
  let b = parseInt(hexcolor.substring(4, 6), 16);

  // Determine the brightness of the background
  let brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // If brightness is under 128, return white, otherwise return black
  return brightness < 128 ? "white" : "black";
};

const activeItems = ref<HTMLDivElement | null>(null);
const standingRef = ref<HTMLDivElement | null>(null);

const scrollToActiveItem = (container: HTMLDivElement, activeItem: HTMLDivElement) => {
  try {
    if (!container || !activeItem) return;

    const containerRect = container.getBoundingClientRect();
    const activeItemRect = activeItem.getBoundingClientRect();

    const scrollLeft = container.scrollLeft + activeItemRect.left - containerRect.left;

    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  } catch (error) {
    console.error('Error in scrollToActiveItem:', error);
  }
}

const handleShowFull = async () => {
  isShowFull.value = !isShowFull.value;
  await nextTick();

  if (!standingRef.value || !isShowFull.value) return;

  const _tables = standingRef.value.querySelectorAll<HTMLDivElement>(".as-standing__table") ?? [];
  if (!_tables?.length) return;

  Array.from(_tables).forEach((table) => {
    try {
      const activeItem = table.querySelector<HTMLDivElement>(".as-scroll-item-active");
      if (!activeItem) return;
    
      requestAnimationFrame(() => {
        setTimeout(() => {
          scrollToActiveItem(table, activeItem);
        }, 100);
      });
    } catch (error) {
      console.error('Error scrolling to active item:', error);
    }
  });
};
</script>

<script lang="ts">
export default {};
</script>
